<ccl-page-header>
    <div class="s-page-header__left c-page-header__left"><div class="c-title c-title--secondary">Tabs</div></div>
    <div class="s-page-header__right">
        <ccl-toggle-button
            [title]="tabConfig.isTabsEnabled ? 'Enable' : 'Disable'"
            [isChecked]="tabConfig.isTabsEnabled"
            (isCheckedChange)="toggleTabsEnable($event)"
            >{{ tabConfig.isTabsEnabled ? "Enabled" : "Disabled" }}</ccl-toggle-button
        >
    </div>
</ccl-page-header>
<ccl-content-section *ngIf="tabConfig.isTabsEnabled">
    <div class="row row--builder">
        <div class="col col-sm-6">
            <label for="tabStyle">Tab Style</label>
            <ccl-simple-select formId="tabStyle"
                [listOfItems]="tabStyles"
                (valueChange)="tabConfig.tabStyle = $event.value"
                [value]="tabConfig.tabStyle"
                [bindLabel]="'label'"
                [bindValue]="'code'"
                [isClearable]="false"
            >
            </ccl-simple-select>
        </div>
        <div class="col col-sm-6">
            <label for="tabBasedOn">Tab Based on</label>
            <ccl-simple-select formId="tabBasedOn"
                [listOfItems]="tabBasedOn"
                (valueChange)="tabConfig.tabBasedOn = $event.value"
                [value]="tabConfig.tabBasedOn"
                [bindLabel]="'label'"
                [bindValue]="'code'"
                [isClearable]="false"
            >
            </ccl-simple-select>
        </div>
    </div>
    <p></p>
    <div class="row row--builder">
        <div class="col col-sm-6 text-right"></div>
        <div class="col col-sm-12">
            <div class="c-box" (cclClick)="openConfigDrawer('tab')"
            title="Edit Tabs">
                <div class="pull-left text-center">
                    <div class="tab-data">
                        <div
                            class="tab-element active"
                            [ngStyle]="{
                                color: tabConfig.activeLabelColor,
                                'box-shadow':
                                    tabConfig.tabStyle == 'tab' ? '0 0 3px ' + tabConfig.activeBorderColor : 'none',
                                margin: tabConfig.tabStyle == 'tab' ? '5px' : '5px',
                                background: tabConfig.tabStyle == 'tab' ? tabConfig.activeBorderColor : 'none',
                                'border-bottom': tabConfig.tabStyle == 'tab' ? '0px' : '',
                                'border-bottom-color': tabConfig.activeBorderColor,
                                'border-bottom-style': tabConfig.borderStyle
                            }"
                        >
                            Speaker Type
                        </div>
                    </div>
                    <span class="text-uppercase ml5">Selected Tab</span>
                </div>
                <div class="pull-left text-center">
                    <div class="tab-data">
                        <div
                            class="tab-element"
                            [ngStyle]="{
                                color: tabConfig.inactiveLabelColor,
                                'box-shadow':
                                    tabConfig.tabStyle == 'tab' ? '0 0 3px ' + tabConfig.inactiveBorderColor : 'none',
                                margin: tabConfig.tabStyle == 'tab' ? '5px' : '5px',
                                background: tabConfig.tabStyle == 'tab' ? tabConfig.inactiveBorderColor : 'none',
                                'border-bottom': tabConfig.tabStyle == 'tab' ? '0px' : '',
                                'border-bottom-color': tabConfig.inactiveBorderColor,
                                'border-bottom-style': tabConfig.borderStyle
                            }"
                        >
                            Speaker Type
                        </div>
                    </div>
                    <span class="text-uppercase ml5">Background Tab</span>
                </div>
                <div class="clearfix"></div>
            </div>
        </div>
    </div>
</ccl-content-section>
